import { motion } from "framer-motion";
import { Eyebrow, MaskLine, ease } from "@/components/site/Reveal";

const SHOTS = [
  { src: "/img/cutter-action.webp", label: "Wet cut / concrete slab", cls: "md:col-span-7 aspect-[4/3]" },
  { src: "/img/brick-wall.webp", label: "Ring saw / masonry", cls: "md:col-span-5 aspect-[4/3] md:aspect-auto" },
  { src: "/img/worker-cut.webp", label: "Battery Cutter / site work", cls: "md:col-span-3 aspect-[3/4]" },
  { src: "/img/lps-field.webp", label: "LPS-2400 / field power", cls: "md:col-span-3 aspect-[3/4]" },
  { src: "/img/cutter-closeup.webp", label: "Cutter / water-fed blade", cls: "md:col-span-3 aspect-[3/4]" },
  { src: "/img/breaker-field-poster.webp", video: "/video/breaker-field.mp4", label: "Concrete Breaker / rubble", cls: "md:col-span-3 aspect-[3/4]" },
];

export function Gallery() {
  return (
    <section id="field" data-testid="gallery-section" className="bg-gunmetal py-24 md:py-36">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="mb-12 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <Eyebrow>In the Field</Eyebrow>
            <h2 className="mt-5 font-display text-[12.5vw] sm:text-6xl md:text-8xl font-black uppercase leading-[0.85]" style={{ fontWeight: 900 }}>
              <MaskLine inView>Proof in</MaskLine>
              <MaskLine inView delay={0.1}><span className="text-outline-volt">the cut.</span></MaskLine>
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-12">
          {SHOTS.map((s, i) => (
            <motion.figure
              key={s.src}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, ease, delay: (i % 3) * 0.08 }}
              className={`group relative overflow-hidden ${s.cls}`}
            >
              {s.video ? (
                <video data-testid="gallery-breaker-video" poster={s.src} autoPlay muted loop playsInline preload="metadata" className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105">
                  <source src={s.video.replace(/\.mp4$/, ".webm")} type="video/webm" />
                  <source src={s.video} type="video/mp4" />
                </video>
              ) : (
                <img src={s.src} alt={s.label} loading="lazy" className="absolute inset-0 h-full w-full object-cover grayscale transition-[transform,filter] duration-1000 group-hover:scale-105 group-hover:grayscale-0" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 left-0 flex w-full items-center justify-between p-4 md:p-5">
                <span className="font-mono text-[11px] uppercase tracking-widest text-white">{s.label}</span>
                <span className="font-mono text-[11px] text-volt">0{i + 1}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
